module.exports = __webpack_public_path__ + "img/hotel-do-sado-business-nature.abdc3040.jpg";